import React from 'react';

import { DialogoCreateEdit } from '../../../Components/modulo-gerencial-dialogos';
import { TextInput } from '../../../Components/modulo-gerencial-formularios';

const initialValues = {
  nome: '',
  codigo_teclado: '',
};

const validators = {
  nome: (value) => {
    if (!value) return 'Este campo é obrigatório';
    if (value.length > 80)
      return 'Número de caracteres maior que o permitido (máximo 80)';
    return '';
  },

  codigo_teclado: (value) => {
    if (!value) return 'Este campo é obrigatório';
    if (value.length !== 2) return 'Número de caracteres diferente de 2';
    return '';
  },
};

const transformGetDados = (dados) => ({
  nome: dados.nome,
  codigo_teclado: dados.codigo_teclado,
});

const transformSalvar = (dados) => ({
  nome: dados.nome,
  codigo_teclado: dados.codigo_teclado,
});

function Form() {
  return (
    <>
      <TextInput name="nome" label="Nome" fullWidth autoFocus />
      <TextInput
        name="codigo_teclado"
        label="Código Teclado"
        fullWidth
        mask={(value) => {
          if (value) {
            const codigoSemEspacos = value.trim();
            return codigoSemEspacos.replace(/\D/g, '');
          }
          return '';
        }}
      />
    </>
  );
}

const DialogoSetor = ({ open, id, onClose, isDialogoConfirmacaoActions }) => (
  <DialogoCreateEdit
    open={open}
    id={id}
    resource="setores"
    initialValues={initialValues}
    validators={validators}
    titleCreate="Setor"
    titleUpdate="Setor"
    onClose={onClose}
    transformGetDados={transformGetDados}
    transformSalvar={transformSalvar}
    isCloseTitle
    isDialogoConfirmacaoActions={isDialogoConfirmacaoActions}
  >
    <Form />
  </DialogoCreateEdit>
);

export default DialogoSetor;
